import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '@/components/Login'
import Logout from '@/components/Logout'
import Callback from '@/components/Callback'
import Mobile from '@/components/Mobile'
import SignUp from '@/components/SignUp'

Vue.use(VueRouter)


const routes = [
    { path: "/", component: Login },
    { path: "/callback", component: Callback },
    { path: "/mobile", component: Mobile },
    { path: "/logout", component: Logout},
  { path: "/sign-up", component: SignUp }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

export default router
